import { createDeleteEndpoint } from '@sonar-software/sonar-http';

export type DeleteDataSecurityMonitorByIdRequest = {
	monitorId: number;
};

export const deleteDataSecurityMonitor = createDeleteEndpoint<DeleteDataSecurityMonitorByIdRequest>(
	({ monitorId }) => `/api/v3/data-security/monitors/${monitorId}`
);
